/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Vo_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to export audio VO" |
*
* @param {Audio_Description_Export_Status_Vo_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_failed = /** @type {((inputs?: Audio_Description_Export_Status_Vo_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'export de la VO")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioexport (Sprachausgabe) fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile esportare l'audio VO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось экспортировать аудиозапись.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo exportar el audio VO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出音频 VO 失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオVOのエクスポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो वॉयस ओवर निर्यात करने में विफल।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha na exportação do áudio VO")
	return /** @type {LocalizedString} */ ("Failed to export audio VO")
});